import type { ImportMode } from "./fields";

interface PropertyOption {
  id: string;
  name: string;
  address: string;
}

export function downloadTemplate(importMode: ImportMode, properties: PropertyOption[]) {
  const headers = [
    "property_id", "name", "asset_type", "status", "manufacturer", "model",
    "serial_number", "asset_code", "condition", "purchase_date", "purchase_price",
    "warranty_expires", "last_maintenance", "next_maintenance", "manufacture_date",
    "installation_date", "commission_date", "size_tons", "system_type", "gas_pack",
    "mounting_type", "separate_air_handler", "refrigerant_type", "health_score",
    "lifecycle_stage", "remaining_useful_life_months", "total_cost_ownership",
    "mtbf_hours", "mttr_hours", "availability_percentage", "energy_consumption_12m",
    "co2_emissions_12m", "notes",
  ];

  const instructions = [
    "Instructions:",
    importMode === "single"
      ? "- property_id: Leave blank, will be set based on your selection"
      : "- property_id: Required for multi-property import. Use exact property UUID from your accessible properties",
    "- asset_type: HVAC, Plumbing, Electrical, Lighting, Security, Fire Safety, Elevator, Generator, Appliance, Furniture, IT Equipment, Other",
    "- status: Active, Maintenance, Out-of-Service, Decommissioned",
    "- condition: New, Good, Fair, Poor",
    "- Dates: Use YYYY-MM-DD format",
    "- Boolean fields (gas_pack, separate_air_handler): TRUE or FALSE",
    "- Numbers: Use decimal format (e.g., 5.5 for size_tons)",
  ];

  if (importMode === "multi" && properties.length > 0) {
    instructions.push("", "Available Property IDs:");
    properties.forEach((prop) => {
      instructions.push(`- ${prop.id} (${prop.name})`);
    });
  }

  const samplePropertyId = importMode === "multi" && properties.length > 0
    ? properties[0].id
    : "";

  const sampleData = [
    {
      property_id: samplePropertyId,
      name: "RTU-001",
      asset_type: "HVAC",
      status: "Active",
      manufacturer: "York",
      model: "ZF060E10P2JAA2A",
      serial_number: "N1G3966719",
      asset_code: "RTU-001",
      condition: "Fair",
      purchase_date: "2020-01-15",
      purchase_price: "15000",
      warranty_expires: "2025-01-15",
      last_maintenance: "2024-06-01",
      next_maintenance: "2024-12-01",
      manufacture_date: "2019-12-01",
      installation_date: "2020-01-15",
      commission_date: "2020-01-20",
      size_tons: "5",
      system_type: "Rooftop Unit",
      gas_pack: "TRUE",
      mounting_type: "Rooftop",
      separate_air_handler: "FALSE",
      refrigerant_type: "R-410A",
      health_score: "85",
      lifecycle_stage: "operation",
      remaining_useful_life_months: "149",
      total_cost_ownership: "",
      mtbf_hours: "",
      mttr_hours: "",
      availability_percentage: "",
      energy_consumption_12m: "",
      co2_emissions_12m: "",
      notes: "HVAC rooftop unit in good working condition",
    },
  ];

  const csvContent = [
    headers.join(","),
    ...instructions.map((line) => `"${line}"`),
    "",
    ...sampleData.map((row) => headers.map((header) => `"${row[header as keyof typeof row] || ""}"`).join(",")),
    "",
    ...Array(20).fill(null).map(() => headers.map(() => '""').join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "asset_import_template.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
